import { TrendAlertColumn } from "./types";

export const VOLUME_ALERTS_TABLE_COLUMNS: TrendAlertColumn[] = [
  {
    key: "name",
    labelKey: "Topic",
    style: { width: "20%" },
  },
  {
    key: "condition",
    labelKey: "Condition",
    style: { width: "30%" },
  },
  {
    key: "targetVolume",
    labelKey: "Target Volume",
    style: { width: "20%" },
  },
  {
    key: "currentVolume",
    labelKey: "Current Volume",
    style: { width: "20%" },
  },
  {
    key: "edit",
    labelKey: "More",
    style: { width: "10%" },
  },
];

export const NEW_DATA_ALERTS_TABLE_COLUMNS: TrendAlertColumn[] = [
  { key: "name", labelKey: "Topic", style: { width: "40%" } },
  { key: "condition", labelKey: "Condition", style: { width: "30%" } },
  { key: "minVolume", labelKey: "Min Volume", style: { width: "20%" } },
  { key: "edit", labelKey: "More", style: { width: "10%" } },
];
